/**
 * Created by jonas on 2020-10-01.
 */


import {Back, Linear, Power2, TimelineLite, TweenMax, gsap} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {APIEventSystem} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { PossessedSymbolStates } from "../../../game/reels/PossessedSymbol";
import {PossessedSymbol} from "../../../game/reels/PossessedSymbol";
import {PossessedStatics} from '../../../game/config/PossessedStatics';
import {CustomEase} from "gsap/dist/CustomEase";
import {Possessed} from "../../../game/Possessed";
import { PossessedSymbolFactory } from "../../../game/reels/PossessedSymbolFactory";

export interface Positionable {
    position:{
        x:number,
        y:number
    }
}

export interface SimpleReelModelSymbolPosition {
    reelID:number;
    position:number
}


//export interface SimpleReelModelDelegate {
//    createSymbol(symbolName:string, state:SimpleReelModelState, reelID:number, reelPosition:number):ExorcismSymbol;
//
//    removeSymbol(symbolData:ExorcismSymbol):void;
//}

//export interface SimpleReelModelSymbolData {
//    name:string,
//    positionable:Positionable,
//    reelPosition:number
//}

export enum SimpleReelModelState {
    IDLE = "IDLE",
    START = "START",
    SPIN = "SPIN",
    STOP = "STOP",
    STOPPED = "STOPPED",
    BOUNCE = "BOUNCE",
    NUDGE = "NUDGE",
}

export interface SimpleReelModelEventData {
    reel:number;
    state:SimpleReelModelState;
}


export interface SimpleReelPaddingData {
    visualPaddingBefore:number;
    paddingBefore:number;
    visibleSymbols:number;
    paddingAfter:number;
    visualPaddingAfter:number;
}

export class SimpleReelModel extends PIXI.Container {
    private stopTriggerTl:gsap.core.Timeline | undefined;

    public setSpeed(value:number) {
        this.speed = value;
        this.animationTimeScale = value * this.stepDuration;
        this.masterSpinTimeline?.timeScale(this.animationTimeScale);
    }
    public getSpeed():number {
        return this.speed;
    }

    get state():SimpleReelModelState {
        return this._state;
    }

    set state(value:SimpleReelModelState) {
        this._state = value;
        if (this.events) {
            this.events.trigger("ReelStateChange", <SimpleReelModelEventData>{reel:this.id, state:this._state});
        }
    }

    //Fake reel
    public reelSet:string[] = [];
    private reelSetIndex:number = 0;

    private stopIndex:number;
    public stopSymbols:PossessedSymbol[] = [];
    public symbols:PossessedSymbol[] = [];

    public paddingConfig:SimpleReelPaddingData = {
        visualPaddingBefore:0,
        paddingBefore:1,
        visibleSymbols:3,
        paddingAfter:1,
        visualPaddingAfter:0,
    }

    public animatedStepData = {
        y:0
    }

    public stepSize:number = 180;
    private spinning:boolean = false;
    private currentSpinStep:gsap.core.Tween | undefined;


    private animationTimeScale = 1;
    public stepDuration = 0.1;

    private stopTimeline:TimelineLite | undefined;

    private stopping:boolean = false;
    private triggerStop:boolean = false;


    private speed:number = this.animationTimeScale / this.stepDuration;
    private masterSpinTimeline:TimelineLite | undefined;


    private _state:SimpleReelModelState = SimpleReelModelState.IDLE;


    public readonly id:number;
   // private delegate:SimpleReelModelDelegate;
    private nudgeSteps:number = 0;

    private symbolMask:PIXI.Graphics;

    /**
     * Triggers on: ReelStateChange and each ReelModelState
     *
     *
     */
    public readonly events:APIEventSystem | undefined;

    constructor(id:number, triggerEvents:boolean = false) {
        super();
        this.id = id;
        if (triggerEvents) {
            this.events = SlotGame.apiPlugin.eventSystemFactory.create();
            this.events.on("ReelStateChange", (data:SimpleReelModelEventData) => this.onReelStateChange(data)); //To prevent event system from saving once callbacks if no on callbacks is set.
        }
    }

    public setReelSet(reelSet:string[], index?:number){
        this.reelSet = reelSet;
        index = index != undefined ? index : Math.floor(Math.random() * this.reelSet.length);
        this.setReelIndex(index);
    }

    private onReelStateChange(data:SimpleReelModelEventData):void {
        this.events?.trigger(data.state, data);
    }

    private getNextSymbolName(nextSymbolPosition:number):string {
        let nextIndex = this.reelSetIndex + nextSymbolPosition;
        if (nextIndex < 0) {
            nextIndex = this.reelSet.length + nextIndex;
        }
        if (nextIndex >= this.reelSet.length) {
            nextIndex = nextIndex - this.reelSet.length;
        }
        return this.reelSet[nextIndex];

    }

    private getNextSymbol(position:number, state:SimpleReelModelState):PossessedSymbol {
        if (this.stopping && this.stopSymbols.length > 0) {
            const symbol = this.stopSymbols[this.stopIndex];
            symbol.reelPosition = position;
            return symbol;
        }
        //Default
        return this.createNewSymbol(this.getNextSymbolName(position), position, state)
    }

    public createNewSymbol(name:string, position:number, state:SimpleReelModelState):PossessedSymbol {
        let symbolState:PossessedSymbolStates;
        switch (state) {
            case SimpleReelModelState.SPIN:
                symbolState = PossessedSymbolStates.SPIN;
                break;
            case SimpleReelModelState.STOP:
                symbolState = PossessedSymbolStates.STOP;
                break;
            default:
                symbolState = PossessedSymbolStates.NORMAL;
                break;
        }
        const symbol = PossessedSymbolFactory.createSymbol(name, this.id, position, symbolState);
        symbol.position.x = this.id * PossessedStatics.SYMBOL_WIDTH + PossessedStatics.SYMBOL_WIDTH*0.5;
        symbol.position.y = PossessedStatics.SYMBOL_HEIGHT* position;
        if(symbol.name == "W" && state == SimpleReelModelState.STOP) {
            Possessed.reelView.wildSymbolsView.addSymbol(symbol);
        } else if(name === "S" && state == SimpleReelModelState.STOP) {
          Possessed.reelView.scatterSymbolsView.addSymbol(symbol);
        } else {
            this.addChild(symbol);
        }
        return symbol;
    }

    public getRandomSymbolInReelSet():string {
        const randomIndex = Math.floor(Math.random() * this.reelSet.length);
        return this.reelSet[randomIndex];
    }

    private clearSymbols(symbols:PossessedSymbol[]):void {
        let symbol;
        while (symbol = symbols.pop()){
            this.removeChild(symbol);
            //this.delegate.removeSymbol(symbol);
            symbol.destroy();
        }
    }


    private getRandomSymbols(count:number):string[]{
        const result:string[] = [];
        for (let i:number = 0; i < count; i++){
            result.push(this.getRandomSymbolInReelSet());
        }
        return result;
    }

    public init(symbols:string[]) {
        this.clearSymbols(this.symbols);
        this.clearSymbols(this.stopSymbols);

        const totalCount = this.paddingConfig.visualPaddingBefore + this.paddingConfig.paddingBefore + this.paddingConfig.visibleSymbols + this.paddingConfig.paddingAfter + this.paddingConfig.visualPaddingAfter;
        const totalInitCount = this.paddingConfig.paddingBefore + this.paddingConfig.visibleSymbols + this.paddingConfig.paddingAfter;

        if (symbols.length != totalInitCount){
            Logger.warn(`ReelModel.init:  Symbol count mismatch in reel ${this.id}`);
        }

        symbols = this.getRandomSymbols(this.paddingConfig.visualPaddingBefore).concat(symbols);
        symbols = symbols.concat(this.getRandomSymbols(this.paddingConfig.visualPaddingAfter));

        for (let i:number = 0; i < symbols.length; i++) {
            const symbol = this.createNewSymbol(symbols[i], i - this.paddingConfig.visualPaddingBefore - this.paddingConfig.paddingBefore, SimpleReelModelState.IDLE);
            this.symbols.push(symbol);
            this.stopSymbols.push(symbol);
        }

        this.symbolMask = new PIXI.Graphics();
        const symWidth  = PossessedStatics.SYMBOL_WIDTH;
        const symHeight = PossessedStatics.SYMBOL_HEIGHT;

        this.symbolMask.beginFill();
        this.symbolMask.drawRect(this.id * symWidth - symWidth, -symHeight / 2.0, symWidth*3, this.paddingConfig.visibleSymbols * symHeight);
        
        //this.mask = symbolsMask;
        //this.addChild(this.mask);
        this.getOverflowSymbols().forEach(s => s.visible = false);

        this.updatePosition();
    }

    public halt(){
        if (this.currentSpinStep){
            this.masterSpinTimeline?.kill();
            this.currentSpinStep?.progress(1);
        }
    }

    public resume(){
        this.startSpin();
    }

    public stop(stopSymbolNames:string[], anticipation:boolean = false, reverse:boolean=false):gsap.core.Timeline {
        this.clearSymbols(this.stopSymbols);

        this.stopSymbols = [];
        stopSymbolNames = this.getRandomSymbols(this.paddingConfig.visualPaddingBefore).concat(stopSymbolNames);
        stopSymbolNames = stopSymbolNames.concat(this.getRandomSymbols(this.paddingConfig.visualPaddingAfter));
        for (let i:number = 0; i < stopSymbolNames.length; i++) {
            const symbol = this.createNewSymbol(stopSymbolNames[i], i - this.paddingConfig.visualPaddingBefore - this.paddingConfig.paddingBefore, SimpleReelModelState.STOP);
            symbol.position.y = this.stepSize * - (this.paddingConfig.visualPaddingBefore + this.paddingConfig.paddingBefore + this.paddingConfig.visibleSymbols);
            this.stopSymbols.push(symbol);
        }

        this.stopTriggerTl = gsap.timeline({
            paused:true,
            onStart:() => {
                this.state = SimpleReelModelState.STOP;
                this.spinning = false;
                this.triggerStop = true;
            }
        });

        this.stopTimeline = new TimelineLite({
            paused:true,
            onStart:() => {
                this.stopIndex = reverse ? 0 : stopSymbolNames.length - 1;
                this.stopping = true;
            },
            onComplete:() => {
                this.state = SimpleReelModelState.STOPPED;
                this.stopTimeline = undefined;
                this.stopping = false;
                this.state = SimpleReelModelState.IDLE;
            }
        });

        const numberOfNormalSteps = this.paddingConfig.visualPaddingBefore + this.paddingConfig.paddingBefore +  this.paddingConfig.visibleSymbols  + this.paddingConfig.paddingAfter + this.paddingConfig.visualPaddingAfter;
        if(anticipation) {
            const anticipationEase = CustomEase.create("custom", "M0,0 C0.126,0.382 0.182,0.453 0.323,0.618 0.466,0.786 0.818,1.001 1,1 ");
            this.stopTimeline.add(this.stepsAnticipation(numberOfNormalSteps, 1, anticipationEase, reverse));
        } else {
            for (let i:number = 0; i < numberOfNormalSteps; i++) {
                const tween = this.step(reverse);
                this.stopTimeline.add(tween);
            }
        }
        this.stopTimeline.add(() => {
            for(let symbol of this.stopSymbols) {
                symbol.crossFadeFromSpin(0.1);
            }
        }, anticipation ? ">" :"<")

        //! Bounce is required to be called for this reel effect to work properly for now. 
        //! It can just be called with duration and bounce factor of 0 if no bounce is desired.
        if(!anticipation) {
           this.stopTimeline.add(() => {this.bounce(0.2, 1, reverse)});
        } else {
            this.stopTimeline.add(() => {
                this.bounce(0, 0, reverse);
            })
        }

        //this.stopTriggerTl.add(new TweenMax(this, this.stopTimeline.totalDuration(), {}));
        this.stopTriggerTl.add(gsap.to(this, {duration: this.stopTimeline.totalDuration()}));

        return this.stopTriggerTl.play(0);
    }

    public start(reverse:boolean = false, duration:number = this.stepDuration * 8):TimelineLite {
        const tl:TimelineLite = new TimelineLite({
            onStart:() => {
                this.state = SimpleReelModelState.START;
                this.stopSymbols = [];
                this.nudgeSteps = 0;

                this.mask = this.symbolMask;
                this.addChild(this.symbolMask);

                this.symbols.forEach(s => s.visible = true);
            },
            onComplete:() => {
                this.startSpin(reverse);
            }
        });

        const tween = this.step(reverse);
        //tween.vars.ease = Back.easeIn.config(3);
        tween.vars.ease = "back.in(3)";
        tween.totalDuration(duration);

        tl.add(tween);

        return tl;
    }

    public bounce(bounceFactor:number = 0.2, durationFactor:number = 1, reverse:boolean = false):TimelineLite {
        const tl = new TimelineLite();
        const overshoot = TweenMax.to(this.animatedStepData, this.stepDuration * durationFactor, {
            y:reverse ? -this.stepSize * bounceFactor : this.stepSize * bounceFactor,
            ease:Power2.easeOut,
            onStart:() => {
                this.state = SimpleReelModelState.BOUNCE;
            },
            onUpdate:() => this.updatePosition(),
            onComplete:() => {
                this.mask = null;
                this.removeChild(this.symbolMask);

                this.getOverflowSymbols().forEach(s => s.visible = false);
            }
        });

        const back = TweenMax.to(this.animatedStepData, this.stepDuration * durationFactor * 2, {
            y:0,
            ease:Power2.easeOut,
            onUpdate:() => this.updatePosition(),
        });

        tl.add(overshoot);
        tl.add(back);

        return tl;
    }

    private startSpin(reverse:boolean = false) {
        this.spinning = true;
        this.state = SimpleReelModelState.SPIN;
        this.masterSpinTimeline = new TimelineLite();
        this.masterSpinTimeline.add(() => {
            for(let symbol of this.symbols) {
                symbol.crossFadeToSpin(0.5);
            }
        })
        this.masterSpinTimeline.add(this.spin(reverse));
    }

    private spin(reverse:boolean = false):TimelineLite {
        const tl:TimelineLite = new TimelineLite({
            onComplete:() => {
                if (this.spinning) {
                    this.masterSpinTimeline?.add(this.spin(reverse));
                    //this.spin(reverse);
                }
            }
        })
        tl.add(this.step(reverse));
        return tl;
    }

    stepsAnticipation(numberOfSteps:number, duration:number, ease:any, reverse:boolean = false):gsap.core.Tween {
       return gsap.to(this.animatedStepData, {
            y: reverse ? numberOfSteps * -this.stepSize : numberOfSteps * this.stepSize,
            ease: ease,
            duration: duration,
            onStart: () => {
                // Add all stop symbols right away
                for(let i:number=0;i<numberOfSteps;i++) {
                    this.addSymbol(reverse);
                    this.updateIndex(reverse);
                }
                this.updatePosition();
            },
            onUpdate: () => {
                this.updatePosition();
            },
            onComplete: () => {
                // Update reelPostions and remove overflow
                this.symbols.forEach(sym => {
                    sym.reelPosition += reverse ? -numberOfSteps : numberOfSteps;
                })

                this.animatedStepData.y = 0;

                if (this.triggerStop) {
                    this.triggerStop = false;
                    this.masterSpinTimeline?.kill();
                    this.stopTimeline?.play(0);
                }
                this.removeSymbol();
                this.updatePosition();

            }
        });
    }

    private step(reverse:boolean = false) {
        const tween:gsap.core.Tween = gsap.to(this.animatedStepData, {
            duration: this.stepDuration,
            y:reverse ? -this.stepSize : this.stepSize,
            //ease:Linear.easeNone,
            ease: "none",
            onStart:() => this.onAnimationStart(tween, reverse),
            onUpdate:() => this.updatePosition(),
            onComplete:() => this.onAnimationComplete(reverse)
        });
        return tween;
    }

    
    /* 
    public nudge(reverse:boolean = false):TweenMax {
        const tween = this.step(reverse);
        tween.eventCallback("onStart", () => {
            this.nudgeSteps += reverse ? 1 : -1;
            this.state = SimpleReelModelState.NUDGE;
            this.onAnimationStart(tween, reverse);
        });

        return tween;
    }
    */


    private onAnimationStart(tween:gsap.core.Tween, reverse:boolean = false) {
        this.currentSpinStep = tween;
        this.addSymbol(reverse);
    }

    private onAnimationComplete(reverse:boolean = false) {
        for (let i:number = 0; i < this.symbols.length; i++) {
            const symbol = this.symbols[i];
            symbol.reelPosition += reverse ? -1 : 1;
        }

        this.animatedStepData.y = 0;

        if (this.triggerStop) {
            this.triggerStop = false;
            this.masterSpinTimeline?.kill();
            this.stopTimeline?.play(0);
        }

        this.updateIndex(reverse);
        this.removeSymbol();
        this.updatePosition();
    }

    private updateIndex(reverse:boolean) {
        const valueChange = reverse ? 1 : -1
        if (this.stopping) {
            this.setStopIndex(this.stopIndex+valueChange);
        } else {
            this.setReelIndex(this.reelSetIndex+valueChange);
        }
    }

    private setStopIndex(value:number){
        if (value >= this.stopSymbols.length) {
            value = 0;
        }
        else if (value < 0) {
            value = this.stopSymbols.length - 1;
        }
        this.stopIndex = value;
    }

    private setReelIndex(value:number){
        if (value >= this.reelSet.length) {
            value = 0;
        }
        else if (value < 0) {
            value = this.reelSet.length - 1;
        }
        this.reelSetIndex = value;
    }

    private addSymbol(reverse:boolean) {
        let newSymbols = [];
        if (reverse) {
            const newSymbolPosition = this.symbols[this.symbols.length - 1].reelPosition + 1;
            newSymbols.push(this.getNextSymbol(newSymbolPosition, this.state));
            //newSymbols.push(this.createNewSymbol(this.getNextSymbolName(newSymbolPosition), newSymbolPosition, this.state));
        } else {
            const newSymbolPosition = this.symbols[0].reelPosition - 1;
            newSymbols.push(this.getNextSymbol(newSymbolPosition, this.state));
        }

        this.symbols = this.symbols.concat(newSymbols);
        this.symbols.sort((a:any, b:any) => {
            return (a.reelPosition < b.reelPosition) ? -1 : 1;
        })

    }

    private removeSymbol() {
        for (let i:number = this.symbols.length - 1; i >= 0; i--) {
            const symbol = this.symbols[i];
            if (symbol.reelPosition >= this.paddingConfig.visibleSymbols + this.paddingConfig.paddingAfter+ this.paddingConfig.visualPaddingAfter) {
                //Remove from bottom
                const removedSymbol = this.symbols.splice(i, 1)[0];
                this.removeChild(symbol);
                symbol.destroy();
                //this.delegate.removeSymbol(removedSymbol);
            }
            if (symbol.reelPosition < -this.paddingConfig.paddingBefore -this.paddingConfig.visualPaddingBefore) {
                //Remove from top
                const removedSymbol = this.symbols.splice(i, 1)[0];
                this.removeChild(symbol);
                symbol.destroy();
                //this.delegate.removeSymbol(removedSymbol);

            }
        }
    }

    private updatePosition() {
        for (let i:number = 0; i < this.symbols.length; i++) {
            const symbol = this.symbols[i];
            const basePos = this.stepSize * symbol.reelPosition;
            symbol.position.y = basePos + this.animatedStepData.y;
        }
    }

    public getOverflowSymbols():PossessedSymbol[] {
        const overPadding = this.symbols.slice(0, this.paddingConfig.visualPaddingBefore + this.paddingConfig.paddingBefore);
        return overPadding.concat(this.symbols.slice(overPadding.length + this.paddingConfig.visibleSymbols));
    }

    public getAllVisibleStopSymbols():PossessedSymbol [] {
        const paddingBefore = this.paddingConfig.visualPaddingBefore + this.paddingConfig.paddingBefore + this.nudgeSteps;
        return this.stopSymbols.slice(paddingBefore, paddingBefore + this.paddingConfig.visibleSymbols);
    }

    public getAllVisibleSymbols():PossessedSymbol[] {
        const paddingBefore = this.paddingConfig.visualPaddingBefore + this.paddingConfig.paddingBefore + this.nudgeSteps;
        return this.symbols.slice(paddingBefore, paddingBefore + this.paddingConfig.visibleSymbols);
    }

    public getStopSymbolAt(symbolIndex:number):PossessedSymbol {
        return this.stopSymbols[symbolIndex + this.nudgeSteps + this.paddingConfig.paddingBefore];
    }

    public replaceSymbolAt(reelPosition:number, newSym:PossessedSymbol):void {
        //const index = this._stopSymbols.indexOf(this._stopSymbols.find((sym) => sym.reelPosition == reelPosition)!);
        const index = reelPosition + 1;
        this.stopSymbols[index] = newSym;
        this.symbols[index] = newSym;
        this.addChild(newSym);
        //this._delegate.removeSymbol(oldSym);
    }
}